<div class="bg-white pt-5 pb-3 px-3">
	<div class="font-dialog-success-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">{{ "PFM.DO_YOU_KNOW" | translate }}</div>

	<div class="text-center mt-5 mb-4 d-flex justify-content-center">
		<ng-lottie [options]="options" width="120px" height="120px" (animationCreated)="this.onAnimationCreated($event)" class="" />
	</div>

	<div class="mx-3 px-0 font-dialog-success-content" mat-dialog-content>
		<p>{{ this.msgTip }}</p>
	</div>

	<div class="d-flex justify-content-center my-2">
		<div class="my-0" [ngClass]="srvRpDesign.getResponsiveClass('d-flex justify-content-center', 'mobile-layout')">
			<button class="p-4 font-button button-action-cancel" mat-button [mat-dialog-close]="" (click)="onGotIt($event)">{{ "PFM.GOT_IT" | translate }}</button>
			@for(redirect of redirectData; track redirect.label) {
				<button class="p-4 font-button wrap-label button-action-base" [ngClass]="srvRpDesign.appendDesktopClass('ms-2')" mat-button [mat-dialog-close]="" (click)="onRedirect(redirect)" cdkFocusInitial>
					{{ redirect.label }}
				</button>
			}
		</div>
	</div>
</div>